// extracted by mini-css-extract-plugin
export var editButton = "_kv-0";